export const shouldShowVerificationReminder = (session, dismissed = false) =>
	Boolean(session?.user?.email || session?.email) &&
	session?.account_method === "email_password" &&
	session?.email_verified === false &&
	!dismissed

export const verificationReminderEmail = (session) => session?.user?.email || session?.email || ""

export const verificationReminderDismissalKey = (session) => {
	const userId = session?._id
	const sessionId = session?.verification_reminder_session_id
	return userId && sessionId ? `sv_verification_reminder_dismissed:${userId}:${sessionId}` : null
}
